import React from 'react';
import { Lexicon, EditWrapper } from '@nitidbit/lexicon';
import LinkPill from '../LinkPill/LinkPill';
import ModalWithOverlay from '../Modal/ModalWithOverlay';
import text from './LinkModalStrings.json';
import { LEXICON_URL } from '../../constants';

import './LinkModal.scss';

const LinkModal = ({ isModalOn, modalClickHandler, lexicon }) => (
  <ModalWithOverlay
    clickHandler={modalClickHandler}
    isModalOn={isModalOn}
    closeBox="close box"
  >
    <div className="modal-content">
      <p>{lexicon.get('modal_text')}</p>
      <div className="link-container">
        <LinkPill
          link="http://www.mypathtool.org/"
          text="MyPath"
        />
        <LinkPill
          link="http://va.mypathtool.org/"
          text="MyPath for Veterans"
        />
      </div>
    </div>
  </ModalWithOverlay>
);

const LinkModalLexicon = new Lexicon(text, 'en', 'src/shared/LinkModal/LinkModalStrings.json');

const EditableLinkModal = (props) => (
  <EditWrapper
    component={(editProps) => <LinkModal {...{ ...props, ...editProps }} />}
    lexicon={LinkModalLexicon}
    apiUpdateUrl={LEXICON_URL}
  />
);

export default EditableLinkModal;
